import { createDirtyChecker, compareByPaths } from "../gvc/testNewForm/createDirtyChecker";
import { inputToOrgPatch } from "../../schema/types/org/utils";
import { isEqual, get } from "lodash";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToOrgPatch, (initItem, currItem, initRaw, currRaw) => {
    const dirty = compareByPaths({
      description: { path: "description" },
      tracing: { path: "spec.tracing" },
      sessionTimeoutSeconds: { path: "spec.sessionTimeoutSeconds" },
      authConfig: { path: "spec.authConfig" },
      observability: { path: "spec.observability" },
      security: { path: "spec.security" },
      tags: { path: "tags" },
    })(initItem, currItem);

    // Per-tab dirty keys using converted output (strips undefined/UI fields naturally)
    // logging[0] → spec.logging; logging[i>0] → spec.extraLogging[i-1]
    const maxLen = Math.max(initRaw?.logging?.length || 0, currRaw?.logging?.length || 0);
    if (maxLen > 0) {
      if (!isEqual(get(initItem, "spec.logging"), get(currItem, "spec.logging"))) {
        dirty["logging.0"] = true;
      }
      const initExtra: any[] = get(initItem, "spec.extraLogging") || [];
      const currExtra: any[] = get(currItem, "spec.extraLogging") || [];
      const extraLen = Math.max(initExtra.length, currExtra.length);
      for (let i = 0; i < extraLen; i++) {
        if (!isEqual(initExtra[i], currExtra[i])) {
          dirty[`logging.${i + 1}`] = true;
        }
      }
    }

    return dirty;
  });
}
